import { Injectable } from '@angular/core';
import { LayoutGapParent, LayoutGapStyleBuilder } from '@angular/flex-layout/flex';
import { StyleDefinition } from '@angular/flex-layout/core';

/**
 * flex-layout re-applies fxLayoutGap whenever children are added or removed, using the value for
 * the active breakpoint. With only a responsive gap (e.g. fxLayoutGap.gt-sm) and no active match,
 * that value is undefined and the stock builder throws on `gapValue.endsWith`.
 */
@Injectable()
export class SafeLayoutGapStyleBuilder extends LayoutGapStyleBuilder {
  override buildStyles(gapValue: string, parent: LayoutGapParent): StyleDefinition {
    return super.buildStyles(gapValue ?? '0px', parent);
  }

  override sideEffect(gapValue: string, styles: StyleDefinition, parent: LayoutGapParent): void {
    super.sideEffect(gapValue ?? '0px', styles, parent);
  }
}
